import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import MenuBar, { MenuHeader, MenuSection } from '../../components/new-layout/MenuBar';
import PageLayout from '../../components/new-layout/PageLayout';
import * as routing from '../../constants/Routing';
import { useAsUser } from '../../hooks/session/useAsUser';
import { useRetrieveUserCredentials } from '../../hooks/user/useRetrieveUserCredentials';
import Text from '../../react-components/Text';
import eventsPanel, { PageViewPages } from '../../services/events';
import { BackofficeClientsOrganizations } from './clients/organizations';
import { BackofficeClientsProjects } from './clients/projects';
import { BackofficeClientsUsers } from './clients/users';
import { BackofficeContextProvider } from './context';
import { BackofficeTranslations } from './translations';

export const Backoffice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { asUser } = useAsUser();

  useEffect(() => {
    eventsPanel.pageView(PageViewPages.backoffice);
  }, []);

  return (
    <BackofficeContextProvider>
      <PageLayout>
        <>
          <MenuBar
            content={
              <div>
                <MenuHeader>
                  <Text variant="h6" intlId="backoffice.title" />
                </MenuHeader>
                {userCredentials?.isStaff(asUser) ? (
                  <>
                    <MenuSection
                      id={routing.BACKOFFICE.CLIENTS.ROOT}
                      active={
                        location.pathname.includes(routing.BACKOFFICE.CLIENTS.USERS) ||
                        location.pathname.includes(routing.BACKOFFICE.CLIENTS.ORGANIZATIONS) ||
                        location.pathname.includes(routing.BACKOFFICE.CLIENTS.PROJECTS)
                      }
                      textIntlId="backoffice.leftbar.clients"
                      textStyle={{ fontWeight: `bold` }}
                      onClick={() => {
                        navigate(routing.BACKOFFICE.CLIENTS.USERS);
                      }}
                    />
                    <MenuSection
                      id={routing.BACKOFFICE.CLIENTS.USERS}
                      active={location.pathname.includes(routing.BACKOFFICE.CLIENTS.USERS)}
                      textIntlId="backoffice.leftbar.clients.users"
                      indent={1}
                      onClick={() => {
                        navigate(routing.BACKOFFICE.CLIENTS.USERS);
                      }}
                    />
                    <MenuSection
                      id={routing.BACKOFFICE.CLIENTS.ORGANIZATIONS}
                      active={location.pathname.includes(routing.BACKOFFICE.CLIENTS.ORGANIZATIONS)}
                      textIntlId="backoffice.leftbar.clients.organizations"
                      indent={1}
                      onClick={() => {
                        navigate(routing.BACKOFFICE.CLIENTS.ORGANIZATIONS);
                      }}
                    />
                    <MenuSection
                      id={routing.BACKOFFICE.CLIENTS.PROJECTS}
                      active={location.pathname.includes(routing.BACKOFFICE.CLIENTS.PROJECTS)}
                      textIntlId="backoffice.leftbar.clients.projects"
                      indent={1}
                      onClick={() => {
                        navigate(routing.BACKOFFICE.CLIENTS.PROJECTS);
                      }}
                    />
                  </>
                ) : null}

                {/* <MenuSection
                id={routing.BACKOFFICE.USAGE}
                active={location.pathname === routing.BACKOFFICE.USAGE}
                intlId="backoffice.leftbar.usage"
                style={{ fontWeight: `bold` }}
                onClick={() => {
                  navigate(routing.BACKOFFICE.USAGE);
                }}
              />

              <MenuSection
                id={routing.BACKOFFICE.ACQUISITION}
                active={location.pathname === routing.BACKOFFICE.ACQUISITION}
                intlId="backoffice.leftbar.acquisition"
                style={{ fontWeight: `bold` }}
                onClick={() => {
                  navigate(routing.BACKOFFICE.ACQUISITION);
                }}
              /> */}

                {userCredentials?.test(`can_manage_translations`) && !asUser ? ( // The !asUser is to avoid an admin with no translations permissions to see the translations menu
                  <MenuSection
                    id={routing.BACKOFFICE.TRANSLATIONS}
                    active={location.pathname.includes(routing.BACKOFFICE.TRANSLATIONS)}
                    textIntlId="backoffice.leftbar.translations"
                    textStyle={{ fontWeight: `bold` }}
                    onClick={() => {
                      navigate(routing.BACKOFFICE.TRANSLATIONS);
                    }}
                  />
                ) : null}
              </div>
            }
          />

          <Routes>
            {userCredentials?.isStaff(asUser) ? (
              <Route
                path="/clients/*"
                element={
                  <Routes>
                    <Route index element={<Navigate to={routing.BACKOFFICE.CLIENTS.USERS} />} />
                    <Route path="/users/*" element={<BackofficeClientsUsers />} />
                    <Route path="/organizations/*" element={<BackofficeClientsOrganizations />} />
                    <Route path="/projects/*" element={<BackofficeClientsProjects />} />
                    <Route path="*" element={<Navigate to={routing.BACKOFFICE.CLIENTS.USERS} />} />
                  </Routes>
                }
              />
            ) : null}

            {/* <Route path="/usage" element={<BackofficeUsage />} />

          <Route path="/acquisition" element={<BackofficeAcquisition />} /> */}

            {userCredentials?.test(`can_manage_translations`) && !asUser ? ( // The !asUser is to avoid an admin with no translations permissions to see the translations menu
              <Route path="/translations/*" element={<BackofficeTranslations />} />
            ) : null}

            <Route path="*" element={<Navigate to={routing.BACKOFFICE.CLIENTS.USERS} />} />
          </Routes>
        </>
      </PageLayout>
    </BackofficeContextProvider>
  );
};
